import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({ baseURL: API_URL, headers: { 'Content-Type': 'application/json' }, timeout: 10000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('client');
    }
    return Promise.reject(error);
  }
);

// Client Portal APIs only (no admin access)
// Accepts an object: { email, password, inviteToken }
export const clientLogin = async ({ email, password, inviteToken }) => {
  const response = await api.post('/auth/client/login', { email, password, inviteToken });
  return response.data;
};

export const getClientInvoices = async () => {
  const response = await api.get('/invoices');
  return response.data;
};

export const updateInvoiceStatus = async (id, status) => {
  const response = await api.patch(`/invoices/${id}/status`, { status });
  return response.data;
};

export const getInvoiceDocuments = async (invoiceId) => {
  const response = await api.get(`/invoices/${invoiceId}/documents`);
  return response.data;
};

export const getNotificationSummary = async (params = {}) => {
  const response = await api.get('/notifications/summary', { params });
  return response.data;
};

// Change client password (authenticated client)
export const clientChangePassword = async ({ currentPassword, newPassword }) => {
  const response = await api.patch('/auth/client/password', { currentPassword, newPassword });
  return response.data;
};

export default api;
